"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortPoliciesByDeadline = exports.getExpiredCancellationPolicy = exports.connectionCancellationPolicyMap = exports.connectionBuildCancellationPolicies = void 0;
var formatDate_1 = require("./formatDate");
var date_1 = require("./date");
var connectionCancellationPolicyMap = function (policy) { return ({
    policyCode: policy.policy_code,
    description: policy.description,
    deadline: policy.deadline,
    nonRefundable: policy.non_refundable || false,
    amountPercent: policy.amount_percent ? {
        amount: policy.amount_percent.amount,
        sell: policy.amount_percent.sell,
        currencyCode: policy.amount_percent.currency,
        taxInclusive: policy.amount_percent.tax_inclusive,
    } : undefined,
}); };
exports.connectionCancellationPolicyMap = connectionCancellationPolicyMap;
var sortPoliciesByDeadline = function (a, b) {
    if (a.deadline < b.deadline) {
        return -1;
    }
    if (a.deadline > b.deadline) {
        return 1;
    }
    return 0;
};
exports.sortPoliciesByDeadline = sortPoliciesByDeadline;
var connectionBuildCancellationPolicies = function (policies, options) {
    var policyDescriptions = [];
    if (!(policies === null || policies === void 0 ? void 0 : policies.length) || policies.every(function (policy) { return policy.nonRefundable; })) {
        return {
            policies: [],
            description: [
                'If you cancel your booking, you are not eligible for a refund or credit for a future stay.',
            ],
        };
    }
    var policiesIntTimezone = policies.map(function (policy) {
        // all cancellation policy deadlines are sent as UTC timezone
        // but sometime, the deadline may contain time information (T) without a timezone (Z)
        // we want to make sure the time is still parsed as UTC instead of local time (thanks Javascript Date!)
        // no regression test sadly, since we set our timezone to be UTC when running the test...
        var deadlineString = policy.deadline;
        if (deadlineString.includes('T') && !deadlineString.includes('Z')) {
            deadlineString += 'Z';
        }
        return __assign(__assign({}, policy), { timezone: options.timezone, deadline: new Date(deadlineString) });
    });
    policiesIntTimezone.sort(sortPoliciesByDeadline);
    var expired = policiesIntTimezone.filter(function (policy) { return !policy.deadline || policy.deadline < new Date(); });
    for (var _i = 0, policiesIntTimezone_1 = policiesIntTimezone; _i < policiesIntTimezone_1.length; _i++) {
        var policy = policiesIntTimezone_1[_i];
        if (policy.deadline) {
            var dateFormat = formatDate_1.formattedDateByTimezone(policy.deadline.toISOString(), options.timezone);
            if (!policyDescriptions.length && !(expired.length > 0)) {
                // hideExcludesFlights is used for villa properties, where there are no flights attached.
                policyDescriptions.push("Free accommodation cancellation until " + dateFormat + " (local time of property)" + (options.hideExcludesFlights ? '' : ', excludes flights') + ".");
            }
            if (policy.amountPercent) {
                policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.amountPercent.sell + " " + options.currencyCode + " fee.");
            }
        }
        else {
            policyDescriptions.push(policy.description);
        }
    }
    policyDescriptions.push('If you fail to check-in for this reservation, or if you cancel or change this reservation after check-in, you may incur penalty charges at the discretion of the property of up to 100% of the booking value.');
    return {
        policies: expired.length < policiesIntTimezone.length ? policiesIntTimezone : [],
        description: policyDescriptions,
    };
};
exports.connectionBuildCancellationPolicies = connectionBuildCancellationPolicies;
var getExpiredCancellationPolicy = function (policies, timezone) {
    var policiesMapped = policies.map(connectionCancellationPolicyMap);
    var policiesIntTimezone = policiesMapped.map(function (policy) {
        // see above comment for explanation
        var deadlineString = policy.deadline;
        if (deadlineString.includes('T') && !deadlineString.includes('Z')) {
            deadlineString += 'Z';
        }
        return __assign(__assign({}, policy), { timezone: timezone, deadline: new Date(policy.deadline) });
    });
    policiesIntTimezone.sort(sortPoliciesByDeadline);
    var now = new Date();
    return policiesIntTimezone.find(function (policy) {
        return date_1.datesHaveSameDayMonthYear(now, policy.deadline) || date_1.isAfter(now, policy.deadline) || policy.nonRefundable;
    });
};
exports.getExpiredCancellationPolicy = getExpiredCancellationPolicy;
